import { useParams } from "react-router-dom";
import { IMPACT_METRICS, ImpactMetric, ImpactMetricKey } from "../utils/types";

const getLocalStorageMetricKey = (): string | null => {
  const localMetric = localStorage.getItem("metricKey");
  if (localMetric && Object.keys(IMPACT_METRICS).includes(localMetric)) {
    return localMetric;
  }
  return null;
};

export const setLocalStorageMetricKey = (metricKey?: ImpactMetricKey | null) => {
  if (metricKey && Object.keys(IMPACT_METRICS).includes(metricKey)) {
    localStorage.setItem("metricKey", metricKey);
  } else {
    localStorage.removeItem("metricKey");
  }
};

export const extractImpactMetricKey = (metricKey?: string | null): ImpactMetricKey => {
  const localMetric = getLocalStorageMetricKey();
  if (localMetric && Object.keys(IMPACT_METRICS).includes(localMetric)) {
    return localMetric as ImpactMetricKey;
  }

  if (!metricKey || !Object.keys(IMPACT_METRICS).includes(metricKey)) return "carbon_footprint";
  return metricKey as ImpactMetricKey;
};

export const extractImpactMetric = (metricKey?: string | null): ImpactMetric => {
  const actualMetricKey = extractImpactMetricKey(metricKey);
  return IMPACT_METRICS[actualMetricKey];
};

export function useDashboardImpactMetricKey(): ImpactMetricKey {
  let { dashboardType } = useParams();
  if (dashboardType) {
    setLocalStorageMetricKey(dashboardType as ImpactMetricKey);
  }

  return extractImpactMetricKey(dashboardType);
}

export default function useImpactMetric(): ImpactMetric {
  const impactMetricKey = useDashboardImpactMetricKey();
  return IMPACT_METRICS[impactMetricKey];
}
